import { render, staticRenderFns } from "./branddetails.vue?vue&type=template&id=cf6ce7bc&scoped=true&"
import script from "./branddetails.vue?vue&type=script&lang=js&"
export * from "./branddetails.vue?vue&type=script&lang=js&"
import style0 from "./branddetails.vue?vue&type=style&index=0&id=cf6ce7bc&scoped=true&lang=css&"
import style1 from "./branddetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6ce7bc",
  null
  
)

export default component.exports